import React, { useState } from 'react';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { NoteToolBar } from './NoteToolBar';
import { NoteViewer } from './NoteViewer';
import { NotesListColumn } from './NotesListColumn';
import { Tags } from '../tag/Tags';
import {
	Note as NoteI,
  decrement,
  select,
  addNotes,
  //AddNotesAction,
  incrementByAmount,
  incrementAsync,
  incrementIfOdd,
  selectCount,
  selectNotes,
  testAddNotesPayload,
} from './noteSlice';

export function Note() {
	const viewStyle = {
		height: `calc(100% - 44px)`,
		//backgroundColor: 'purple',
	};
	const mainStyle = {
		height: '100%',
		width: '100%',
		margin: 0,
		//backgroundColor: 'pink',
	};
	const contentStyle = {
		height: '100%',
		width: '100%',
		margin: 0,
		overflow: 'auto',
		display: 'flex',
		//backgroundColor: 'grey',
	};
	const colOneStyle = {
		height: '100%',
		flexGrow: 2,
	};
	const colTwoStyle = {
		height: '100%',
		flexGrow: 4,
		//backgroundColor: 'yellow',
	};
	const colThreeStyle = {
		height: '100%',
		flexGrow: 4,
		overflow: 'auto',
		//backgroundColor: 'red',
	};


	const count = useAppSelector(selectCount);
	const dispatch = useAppDispatch();
	const [incrementAmount, setIncrementAmount] = useState('4');

	const incrementValue = Number(incrementAmount) || 0;

	const notes = useAppSelector(selectNotes);
	console.log(notes);
	const ana = addNotes(testAddNotesPayload);
	let notesList: NoteI[] = [];
	let k: keyof typeof notes;
	for (k in notes) {
		notesList.push(notes[k]);
	}
	const ListItems = notesList.map((note: NoteI) =>
		<li>{note.title}</li>); 
		return (
			<Box sx={viewStyle}>
				<NoteToolBar />
				<Box sx={{height: '100%'}}>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={mainStyle}>
						<Box sx={contentStyle}>
							<Box sx={colOneStyle}>
							<span>{count}</span>
							<button
								aria-label="Increment value"
								onClick={() => dispatch(select({container: 'list', id: '1', value: true}))}
							>
								+
							</button>
							<button
								aria-label="Increment value"
								onClick={() => dispatch(addNotes(testAddNotesPayload))}
							>
								+
							</button>
								<NoteViewer />
								<Tags />
							</Box>
							<Box sx={colTwoStyle}>
							<ul>
								{ListItems}
								<NotesListColumn />
							</ul>
							</Box>
							<Box sx={colThreeStyle}>
							<br /><br /><br /><br /><br /><br /><br /><br /><br />
							<br /><br /><br /><br /><br /><br /><br /><br /><br />
							<br /><br /><br /><br /><br /><br /><br /><br /><br />
							<br /><br /><br /><br /><br /><br /><br /><br /><br />
							. yo man !
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>
		);
}
